import { BonusImage } from '../types/bonus-image';
import { GenericAttachment } from '../types/generic-attachment';
import { GIFItem } from '../types/gif';
import { partial } from '../utils/object';

export const srcToAttachment = (src: string): GenericAttachment => ({
	id: src,
	alt_text: src,
	gif: src,
	mp4: src,
	category: 'social',
});

export const gifToAttachment = ({ content_description, id, media }: GIFItem): GenericAttachment => ({
	id: id,
	alt_text: content_description,
	gif: media[0].gif.url,
	height: media[0].mp4.dims[1],
	mp4: media[0].mp4.url,
	category: 'social',
	width: media[0].mp4.dims[0],
});

export const uploadToAttachment = ({ id, image_name, image_path }: BonusImage): GenericAttachment => ({
	id: id,
	alt_text: image_name,
	gif: image_path,
	mp4: image_path,
	category: 'image',
});

export const getAttachmentAttributes = partial('gif', 'mp4');
